var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.098 11.0198L9.62772 9.5496M9.62772 9.5496C10.0938 9.08348 10.4636 8.53011 10.7159 7.9211C10.9681 7.31208 11.098 6.65934 11.098 6.00015C11.098 5.34095 10.9681 4.68822 10.7159 4.0792C10.4636 3.47018 10.0938 2.91682 9.62772 2.4507C9.1616 1.98458 8.60824 1.61483 7.99922 1.36257C7.39021 1.11031 6.73747 0.980469 6.07827 0.980469C5.41908 0.980469 4.76634 1.11031 4.15733 1.36257C3.54831 1.61483 2.99494 1.98458 2.52882 2.4507C1.58745 3.39207 1.05859 4.66885 1.05859 6.00015C1.05859 7.33145 1.58745 8.60823 2.52882 9.5496C3.4702 10.491 4.74697 11.0198 6.07827 11.0198C7.40958 11.0198 8.68635 10.491 9.62772 9.5496Z",
    stroke: "#818181",
    strokeWidth: 1.41176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f947c882317c1e3964f96f773bcdb1c9.svg";
export { ForwardRef as ReactComponent };